<template>
  <v-layout row wrap>
    <v-flex
      md6
      pa-2
      sm12
      xl4
      xs12
    >
      <v-card>
        <v-form
          lazy-validation
          ref="form"
          v-model="valid"
        >
          <v-toolbar>
            <v-toolbar-title>{{label}} {{prototypeValue.name}}</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-text-field
              :counter="100"
              :rules="nameRules"
              label="Name"
              required
              v-model="prototypeValue.name"
            ></v-text-field>
            <v-text-field
              :rules="emailRules"
              label="Email"
              required
              v-model="prototypeValue.email"
            ></v-text-field>
            <v-select
              v-model="prototypeValue.roles"
              :items="availableRoles"
              label="Roles"
              multiple
            ></v-select>
          </v-card-text>
          <v-card-actions>
            <v-btn
              :disabled="!valid"
              @click="submit"
              color="success"
            >
              Save
            </v-btn>
            <v-btn
              @click="reset"
              color="error"
            >
              Reset
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-flex>
  </v-layout>
</template>
<script>
export default {
  name: 'UserEditFields',
  props: ['value', 'type'],
  data: () => ({
    valid: true,
    nameRules: [
      v => !!v || 'Name is required',
      v => (v && v.length <= 100) || 'Name must be less than 100 characters',
    ],
    emailRules: [
      v => !!v || 'E-mail is required',
      v => /.+@.+/.test(v) || 'E-mail must be valid',
    ],
    prototypeValue: {
    },
    availableRoles: [
      'admin',
      'editor',
    ],
  }),
  computed: {
    label: {
      get() {
        return this.type.charAt(0).toUpperCase() + this.type.slice(1);
      },
    },
  },
  methods: {
    submit() {
      if (this.$refs.form.validate()) {
        this.$emit('input', this.prototypeValue);
      }
    },
    reset() {
      this.initForm();
    },
    initForm() {
      this.prototypeValue = this.value;
    },
  },
  mounted() {
    this.initForm();
  },
};
</script>
